export class AgendaTelefonica {
    
    Id: number;
    Nome: string; 
    CPF_CNPJ: string; 
    RG_IE: string; 
    Endereco: string; 
    EnderecoNumero: string; 
    EnderecoComplemento: string; 
    Bairro: string; 
    CidadeId: number; 
    CEP: string; 
    Telefone: string; 
    Celular: string; 
    Recado: string; 
    Telefone1: string; 
    Telefone2: string; 
    Telefone3: string; 
    Email: string; 
    Ativo: boolean;

    
    constructor () {
        this.Id = 0;
     }  
 
}


export class AgendaTelefonicaLista {
    
    Id: number;
    Nome: string; 
    Cidade: number; 
    Telefone: string; 
    Celular: string; 
    Email: string; 
    constructor () {
        this.Id = 0;
     }  
 
}